var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1143_12157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 4H6.83008L8.83008 6H20.0001V17.17L21.7601 18.93C21.9101 18.65 22.0001 18.34 22.0001 18V6C22.0001 4.9 21.1001 4 20.0001 4Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 10H12.8301L14.8301 12H18.0001V10Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04004 3.86995L2.24004 5.06995C2.09004 5.34995 2.00004 5.65995 2.00004 5.99995V18C2.00004 19.1 2.90004 20 4.00004 20H17.17L20.13 22.9599L21.54 21.5499L2.45004 2.44995L1.04004 3.86995ZM4.00004 6.82995L7.17004 9.99995H6.00004V12H8.00004V10.83L11.17 14H6.00004V16H13.17L15.17 18H4.00004V6.82995Z",
    fill: "#DDDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1143_12157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitle1);
export default __webpack_public_path__ + "static/media/subtitle1.643d3e8c9808353e67e1f6cd0d974288.svg";
export { ForwardRef as ReactComponent };